interface ProjectType {
  id: number;
  image: string;
  categories: string;
  title: string;
  left ? : string;
  top ? : string;
}

const project_data: ProjectType[] = [{
    id: 1,
    image: "/assets/img/bg-img/new-product.jpeg",
    categories: "حلول لوجستية",
    title: "أسطول الشحن البري",
    left: '0',
    top: '0',
  },
  {
    id: 2,
    image: "/assets/img/bg-img/2015.jpg",
    categories: "موانئ وحاويات",
    title: "عمليات الحاويات",
    left: '50',
    top: '0',
  },
  {
    id: 3,
    image: "/assets/img/bg-img/image-5-768x512.jpg",
    categories: "زيوت وتشحيم",
    title: "تخزين الزيوت",
    left: '50',
    top: '608.373',
  },
  {
    id: 4,
    image: "/assets/img/bg-img/5d0324_f2f6cef4d0424a13a7d062549a8bb269~mv2.avif",
    categories: "مستودعات",
    title: "إدارة المخزون",
    left: '0',
    top: '1002.72',
  },
  {
    id: 5,
    image: "/assets/img/bg-img/different-car-accessories-composition.jpg",
    categories: "وقود وحلول طاقة",
    title: "تعبئة الوقود",
    left: '50',
    top: '1401.4',
  },
  {
    id: 6,
    image: "/assets/img/bg-img/image-3.jpg",
    categories: "إطارات وقطع غيار",
    title: "توريد إطارات ثقيلة",
    left: '0',
    top: '1611.09',
  },
];

export default project_data;